import { $ } from "venuescanner-js/tools/elemental";
import { waitFor } from "venuescanner-js/utils/waitFor";

export const reviewsioSetup = () => {
  if ($("#ReviewsWidget").get().length) {
    const js = $("<script>")
      .attr("src", "https://widget.reviews.co.uk/combined/dist.js?RUKcarousel")
      .attr("defer", true);
    const css = $("<link>")
      .attr("rel", "stylesheet")
      .attr(
        "href",
        "https://widget.reviews.co.uk/combined/style.css?RUKcarousel"
      );
    $("head").append(js).append(css);

    waitFor(
      () => {
        return typeof window.ReviewsWidget === "function";
      },
      () => {
        window.ReviewsWidget("#ReviewsWidget", {
          store: "www.venuescanner.com",
          widget: "prestige-card-carousel",
          maxReviews: 21,

          contentMode: "third-party;product;company;",
          sku: "all-product-reviews",

          structuredData: {
            product: "",
            company: "",
          },

          richSnippets: {
            product: true,
            company: true,
          },

          carouselOptions: {
            transitionSpeed: 320,
            draggableOnDesktop: true,
            showSliderArrows: true,
            autoScroll: false,
            autoScrollTime: 15,
            showTitle: true,
            titleText: "Hear what our customers say",
            showSubTitle: true,
            starsInSubTitle: true,
            starsAfterName: false,
            hideDates: true,
            hideThirdParty: true,
          },
          styles: {
            starColor: "#ff747c",
            primaryColor: "#f9f9f9",
            textColor: "#000",
            neutralColor: "#9f9f9f",
            borderRadius: "10px",
            boxShadow: "0 5px 5px rgba(2,2,2,0.1)",
            logoColor: "#000",
            subTitleStar: "#ff747c",
          },
        });
      }
    );
  }
};
